module.exports = __webpack_public_path__ + "html/handover-analysis.component.html";